export default "__VITE_ASSET__mBvGGoPP__"